import { ActionTypes, EventTypes } from './ActionTypes'
import { aggregateApisByType } from './utils/extractApis'

// tslint:disable-next-line:no-empty
const noop = () => ({})

function isService(obj: any) {
  const functionProps = aggregateApisByType(obj)
  return functionProps.length > 0
}

export const defaultService = {
  [ActionTypes.PAGE_VIEW]: noop,
  [ActionTypes.TRACK]: noop,
}

export interface IVendor {
  name: string
  api: any
  conversions?: IConversion
  experimentTracking?: boolean
  events?: EventTypes[]
}

export interface IService {
  name: string | (() => void)
  apis: IAPI
  conversions?: IConversion
  experimentTracking?: boolean
  events?: EventTypes[]
}

export interface IAPI {
  [x: string]: (eventName: string, data: any) => void
}

export interface IConversion {
  dataConversion: Map<EventTypes, (data: any) => any>
  nameConversion?: Map<EventTypes, string>
}

export default function createService(options: IVendor): IService {
  const { api, conversions, experimentTracking, events } = options
  const instance = api || defaultService
  const name = options.name

  return { name, apis: instance, conversions, experimentTracking, events }
}
